module.exports = __webpack_public_path__ + "static/media/icon_transaction_failed.e043f3ba.png";